var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBookingActive = function SvgBookingActive(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2.7998,
    width: 18,
    height: 16.2,
    rx: 1.35,
    stroke: "#082344",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95 1V4.6",
    stroke: "#082344",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.05 1V4.6",
    stroke: "#082344",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.9002C10.7456 10.9002 11.35 10.2958 11.35 9.5502C11.35 8.80461 10.7456 8.2002 10 8.2002C9.25444 8.2002 8.65002 8.80461 8.65002 9.5502C8.65002 10.2958 9.25444 10.9002 10 10.9002Z",
    fill: "#0258FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.95 10.9002C15.6956 10.9002 16.3 10.2958 16.3 9.5502C16.3 8.80461 15.6956 8.2002 14.95 8.2002C14.2044 8.2002 13.6 8.80461 13.6 9.5502C13.6 10.2958 14.2044 10.9002 14.95 10.9002Z",
    fill: "#0258FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04995 15.8504C5.79554 15.8504 6.39995 15.246 6.39995 14.5004C6.39995 13.7548 5.79554 13.1504 5.04995 13.1504C4.30437 13.1504 3.69995 13.7548 3.69995 14.5004C3.69995 15.246 4.30437 15.8504 5.04995 15.8504Z",
    fill: "#0258FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 15.8504C10.7456 15.8504 11.35 15.246 11.35 14.5004C11.35 13.7548 10.7456 13.1504 10 13.1504C9.25444 13.1504 8.65002 13.7548 8.65002 14.5004C8.65002 15.246 9.25444 15.8504 10 15.8504Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookingActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/booking-active.43fd4bbd.svg";
export { ForwardRef as ReactComponent };